import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { sort } from 'fast-sort';
import { SelectItem } from 'primeng/api';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { TranslatableDropdownOption } from '../../../model/src/lib/translatable-dropdown-option.model';
import { ApiCommonService } from './api-common.service';

const COMMON_DROPDOWN_CACHE_KEY = 'commonDropdownOptions';

/**
 * 共用下拉選單服務
 *
 * @export
 * @class DropdownOptionsService
 */
@Injectable({
  providedIn: 'root'
})
export class DropdownOptionsService {

  constructor(
    private apiCommonService: ApiCommonService,
    private translateService: TranslateService) { }

  /**
   * 取的共用下拉選單選項
   *
   * @param {string} [type]
   * @param {string} [code]
   * @param {boolean} [labelDisplayWithValue] display label in "key - value" format
   * @param {boolean} [useCache] 是否使用 cache
   * @return {*}  {Observable<TranslatableDropdownOption[]>}
   * @memberof DropdownOptionsService
   */
  getCommonDropdownOptions(type?: string, code?: string, labelDisplayWithValue?: boolean, useCache: boolean = true): Observable<TranslatableDropdownOption[]> {
    const observer = this.apiCommonService.getDropdownList(type, code)
      .pipe(map(results => {
        const options = sort(results).asc(x => x.sortNo).map(x => new TranslatableDropdownOption(this.translateService, x, labelDisplayWithValue ?? false));
        return options;
      }));
    return observer;
  }

  getPostcodeDropdownOptions(addressCode: string): Observable<SelectItem[]> {
    const observer = this.apiCommonService.addressAddressCodePostcodesGet(addressCode)
      .pipe(
        map(results => results.map<SelectItem<string>>(x => ({ label: x, value: x }))),
        tap(results => sort(results).asc(x => x.value))
      );
    return observer;
  }
}
